import { useState, } from "react";
import axios from "axios";
import { useDispatch, useSelector, } from "react-redux";
import {
    setCartValue, setcartValuePrice,
    setExtractDataFromServiceEmpty, setCartData, setCartItems, setService, setPercentage, setTotalItems,
    setViewOpenandClose,
    setCartValues
} from "../store/slices/IdSlice";
import {
    CartItem,
    TotalQuantity, CartCheckState
} from "../types/cart";
import { closeYesNoModel, openAddModelData, setEditForPackageFalse, setRecentlyAddedTrue } from "../store/slices/modalSlice";
import { useNavigate } from "react-router-dom";
import { IndividualService, VisaPackage } from "../types/callPackage";

const baseUrl = import.meta.env.VITE_API_URL;

export const useCart = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [data, setData] = useState<CartItem[]>([]);
    const [totalItemInCart, setTotalItemInCart] = useState(0);
    const [totalAmountOfCartItem, setTotalAmountOfCartItem] = useState(0);
    const [oldTotalAmount, setOldTotalAmount] = useState(0);
    const [discount, setDiscountValue] = useState(0);
    const [totalQuantity, setTotalQuantity] = useState<TotalQuantity[]>([]);
    const [isOpen, setViewOpenClose] = useState<CartCheckState[]>([]);

    const cartDataaa = useSelector(
        (state: { ID: { cartValues: any } }) => state.ID.cartValues
    );
    const getData = async () => {
        const UUID = localStorage.getItem("uuid");
        if (!UUID) return;

        try {
            const response = await axios.get(
                `${baseUrl}/api/cart/cartinfoNew?UUID=${UUID}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );
            if (response.data) {
                dispatch(setPercentage(response.data.totalProgress))
                dispatch(setTotalItems(response.data.totalItems))
                dispatch(setCartItems(response.data))
                dispatch(setCartData(response.data))
                setData(response.data)
                let ItemInCart = 0;
                let totalAmountOfCartItem = 0;
                const quantityArray: { serviceid: number; Quantity: number }[] = [];

                response.data?.packages?.forEach((item: VisaPackage) => {
                    ItemInCart += 1;
                    totalAmountOfCartItem += item.totalPrice;
                });

                response.data?.services?.forEach((item: IndividualService) => {
                    ItemInCart += 1;
                    totalAmountOfCartItem += item.PriceAmount;
                });

                const cartCheckStatus = response?.data?.packages?.map((item: VisaPackage) => ({
                    cartId: item.cartId,
                    isChecked: false,
                }));

                const discount = oldTotalAmount - totalAmountOfCartItem;
                fetchCartSummary()
                dispatch(setCartValue({ ItemInCart }));
                dispatch(setcartValuePrice({ totalAmountOfCartItem }));
                dispatch(setService(response.data?.services));
                dispatch(setViewOpenandClose(cartCheckStatus))

                setViewOpenClose(cartCheckStatus);
                setTotalItemInCart(ItemInCart);
                setTotalAmountOfCartItem(totalAmountOfCartItem);

                setOldTotalAmount(oldTotalAmount);
                setDiscountValue(discount);
                setTotalQuantity(quantityArray);
            }
        } catch (error) {
        }
    };

    const updateCartQuantity = async (serviceId: number, priceRecordId: number, op: "plus" | "minus", applicantID?: number, optionSelected?: any, extractData?: any, PackageName?: string, cartRecordId?: number, autoOptionSelected?: any) => {
        const UUID = localStorage.getItem("uuid");
        if (!UUID) return;
        try {
            const response = await axios.post(
                `${baseUrl}/api/cart/addCart`,
                {
                    ServiceId: serviceId,
                    Quantity: op === "plus" ? 1 : -1,
                    PriceRecordId: priceRecordId,
                    UUID,
                    applicantid: applicantID,
                    optionSelected,
                    extractData,
                    packageName: PackageName,
                    RecordId: cartRecordId,
                    autoOptionSelected,
                },
                { headers: { "Content-Type": "application/json" } }
            );
            if (response.data) {
                await getData();
                closeGetQuoteModal();
                dispatch(setRecentlyAddedTrue());
                dispatch(setEditForPackageFalse())
                sessionStorage.removeItem("PriceRecordId");
                sessionStorage.removeItem("serviceid");
                sessionStorage.removeItem("text");
                sessionStorage.removeItem("optionSelected");
                sessionStorage.removeItem("CartRecordId");
                sessionStorage.removeItem("autoOptionSelected");
                sessionStorage.removeItem("packageDetails")
                sessionStorage.removeItem("editExtractedData")
                dispatch(setExtractDataFromServiceEmpty());
                dispatch(closeYesNoModel());

            }

        } catch (error) {
            console.error("Error updating cart:", error);
        }

    };

    const deletePackageCart = async (recordId: number) => {
        const UUID = localStorage.getItem("uuid");
        try {
            const response = await axios.delete(`${baseUrl}/api/cart/removePackageCart`, {
                data: {
                    UUID: UUID,
                    RecordId: recordId
                },
                headers: {
                    "Content-Type": "application/json",
                }
            });

            if (response.data.message === "Item removed from cart successfully.") {
                await getData()
            }
        } catch (error: any) {
            console.error("Error:", error.response ? error.response.data : error.message);
        }
    };


    const openModel = (serviceid: number) => {
        sessionStorage.setItem("serviceid", JSON.stringify(serviceid));
        dispatch(openAddModelData());
    };

    const cartRedirect = () => {
        navigate("/cart");
    };

    const getPriceIdByServiceId = (serviceId: number | undefined) => {
        if (!serviceId) return 0;
        
        const foundItem = cartDataaa?.find((item: any) => item.ServiceId === serviceId);
        return foundItem ? foundItem.ServiceId : 0;
    };

    const fetchCartSummary = async () => {
        const UUID = localStorage.getItem("uuid");
        if (!UUID) return;
        try {
            const response = await axios.get(`${baseUrl}/api/cart/cartsummary`, {
                params: {
                    UUID: UUID
                }
            });

            if (response.data) {
                dispatch(setCartValues(response.data.cartSummary));
            }
        } catch (error) {
            console.error('Error fetching cart summary:', error);
        }
    };

    const countByService = (serviceId: number | undefined) => {

        const matchingItem = cartDataaa?.find((item: any) => item.ServiceId === serviceId);

        return matchingItem.Quantity; 
    };

    const closeGetQuoteModal = () => {
        sessionStorage.removeItem("PriceRecordId");
        sessionStorage.removeItem("serviceid");
        sessionStorage.removeItem("text");
        sessionStorage.removeItem("optionSelected");
    };

    const handleToggle = (clickedCartId: number) => {
        setViewOpenClose((prevState) => {
            return prevState?.map((item) => {
                if (item.cartId === clickedCartId) {
                    return { ...item, isChecked: !item.isChecked };
                } else {
                    return { ...item, isChecked: false };
                }
            });
        });
    };


    return {
        data,
        totalItemInCart,
        totalAmountOfCartItem,
        oldTotalAmount,
        discount,
        totalQuantity,
        updateCartQuantity,
        openModel,
        cartRedirect,
        getPriceIdByServiceId,
        countByService,
        closeGetQuoteModal,
        getData, // Allow manual refresh if needed
        deletePackageCart,
        isOpen,
        handleToggle,
        fetchCartSummary,
    };
};
